import React, { useEffect, useState } from "react";
import { Button, InputLabel, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { ResponsiveContainer } from "recharts";
import useStyles from "./style";
import { httpClient } from "appUtility/Api";
import TopInfoBox from "./topInfoBox";
import ThankYouReference from "../../../components/ThankYou";
import EndCallCard from "../../../components/EndCallCard";
import SuspendedFranchiseeInfo from "../../../components/SuspendedFranchiseeInfo";

const qs = require("qs");

const SelectFranchiseChange = (props) => {
  const { radios, setPreviousForwardedScenario } = props;

  const classes = useStyles();
  const [currentFranchiseList, setCurrentFranchiseList] = useState([]);
  const [totalFranchiseData, setTotalFranchiseData] = useState([]);
  const [count, setCount] = useState(0);
  const [stage, setStage] = useState(0);

  const [messageSubmit, setMessageSubmit] = useState(false);
  const [isEndCall, setIsEndCall] = useState(false);

  let commpanyType;
  let loginData = JSON.parse(localStorage.getItem("login"));

  useEffect(() => {
    if (props.franchiseChangeFocus.franchise) {
      setStage(0);
    } else if (props.franchiseChangeFocus.message) {
      setStage(1);
    }
  }, [props.franchiseChangeFocus]);

  useEffect(() => {
    setPreviousForwardedScenario(radios);
  }, []);

  useEffect(() => {
    props.showResetButton && setMessageSubmit(true);
  }, [props.showResetButton]);

  const handleFranchisePress = (e) => {
    if (e.key === "Enter") {
      let params = {
        userID: loginData && loginData.uid,
        userCode: loginData && loginData.aCode,
        appID: 1,
        franchiseeName: e.target.value,
      };

      httpClient
        .post(
          "getSuburbs_Postcode.php",
          qs.stringify({
            action: "get_suburbs",
            source: params,
          })
        )
        .then(({ data }) => {
          if (data) {
            setTotalFranchiseData(data);
            let currFralist = [];
            !data.error &&
              data.map((item) => {
                // item.memberNames.map(mem => {
                //   currFralist.push(mem)
                // })
                currFralist.push(item);
              });
            setCurrentFranchiseList(currFralist);
          }
        });
    }
  };

  const handleFranchiseChange = (e, item) => {
    if (item != null) {
      props.setFranchise(item);
      props.setSuspendedFranchisee(item);
      props.setCompanyID(item.companyID);

      commpanyType = item.businessType;
      setCount(1);
    }
  };

  const handleBack = () => {
    setStage(0);
    props.handleBack();
  };

  const handleSubmit = () => {
    setIsEndCall(false);
    props.handleSubmitFranchiseChange();
  };

  const handleEndCall = () => {
    setIsEndCall(true);
    setMessageSubmit(false);
    props.handleEndCall(props.enquiryDetails);
  };

  // Helper function to determine what message to show
  const getTopInfoBoxMessage = () => {
    if (props.showResetButton) {
      return messageSubmit && !isEndCall
        ? "Thank you for calling, I will pass on your message straight away and have your call returned as soon as possible."
        : "Thank you for call";
    }

    // If we don't have a franchisee selected yet, show initial message
    if (
      !props.suspendedFranchisee ||
      !props.suspendedFranchisee.hasOwnProperty("leadSuspend")
    ) {
      return "May I have the franchise name please?";
    }

    // If franchisee is on leave (leadSuspend === "1")
    if (props.suspendedFranchisee.leadSuspend === "1") {
      return (
        <SuspendedFranchiseeInfo
          suspendedFranchisee={props.suspendedFranchisee}
        />
      );
    }

    // If franchisee is not suspended (leadSuspend === 0)
    if (props.suspendedFranchisee.leadSuspend === "0") {
      if (stage === 1) {
        return "Can you please provide me with details of the message?";
      } else {
        return "Please contact your Management Team for any suburb changes as we cannot action this verbally.";
      }
    }

    // Default fallback
    return "May I have the franchise name please?";
  };

  // Helper function to determine if message input and submit button should be shown
  const shouldShowMessageInput = () => {
    // Don't show if reset button is showing or if franchisee is on leave
    return (
      !props.showResetButton &&
      props.suspendedFranchisee &&
      props.suspendedFranchisee.leadSuspend !== "1"
    );
  };

  return (
    <ResponsiveContainer>
      <div className="row">
        <div className="col-md-12">
          <TopInfoBox text={getTopInfoBoxMessage()} />

          {!props.showResetButton ? (
            <div className={classes.selectBox}>
              <div className="row">
                <div className="col-md-8 mb-4">
                  <InputLabel style={{ marginBottom: "10px" }}>
                    Franchise Name
                  </InputLabel>
                  <Autocomplete
                    options={currentFranchiseList}
                    getOptionLabel={(option) =>
                      option.memberName +
                      " - " +
                      option.businessType +
                      (option.serviceLocation
                        ? " - " + option.serviceLocation
                        : "")
                    }
                    onFocus={props.handleFranchiseChangeFocus}
                    onChange={handleFranchiseChange}
                    onKeyPress={handleFranchisePress}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="franchise"
                        variant="outlined"
                        onFocus={props.handleFranchiseChangeFocus}
                        onBlur={props.handleFranchiseChangeFocusOut}
                        helperText="Press Enter after you enter franchisee name to appear franchisee list."
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            backgroundColor:
                              props.franchise.leadSuspend == "1"
                                ? "#ffd4d4"
                                : props.franchise.leadSuspend == "0"
                                ? "#c6fac6"
                                : "",
                          },
                        }}
                      />
                    )}
                  />
                </div>

                {shouldShowMessageInput() && (
                  <div className="col-md-8 mt-4">
                    <InputLabel className="mb-2">Message</InputLabel>
                    <TextField
                      multiline
                      rows={4}
                      variant="outlined"
                      name="message"
                      value={props.enquiryDetails.message}
                      onChange={props.handleEnquiryChange}
                      className={classes.textField}
                      onFocus={props.handleFranchiseChangeFocus}
                      onBlur={props.handleFranchiseChangeFocusOut}
                      helperText={
                        !props.enquiryDetails.message
                          ? "Please enter the Message"
                          : ""
                      }
                    />
                  </div>
                )}

                <div className="col-md-12 mt-3">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleBack}
                      >
                        Back
                      </Button>

                      {shouldShowMessageInput() && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                          className="ml-3"
                          disabled={!props.enquiryDetails.message}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                    <EndCallCard handleEndCall={handleEndCall} />
                  </div>
                  {props.showResetButton && (
                    <Button
                      variant="contained"
                      className="ml-3"
                      color="default"
                      onClick={props.handleReset}
                    >
                      Reset
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <ThankYouReference
              referenceNumber={props.callRefNumber}
              handleReset={props.handleReset}
            />
          )}
        </div>
      </div>
    </ResponsiveContainer>
  );
};

export default SelectFranchiseChange;
